import { InfiniteScroll } from "./components/InfiniteScroll";
import { MenuDrawer } from "./components/MenuDrawer";
import { MiniCart } from "./components/MiniCart";
import { Modal } from "./components/Modal";
import { SiteOverlay } from "./components/SiteOverlay";
import { SingleClickButtons } from "./components/SingleClickButtons";

class Main {
  constructor() {
    InfiniteScroll.attach();
    MenuDrawer.attach();
    MiniCart.attach();
    Modal.attach();
    SiteOverlay.attach();
    SingleClickButtons.disableButtonMultipleSubmit();
    SingleClickButtons.disableLinkMultipleClick();
    Main.setUpPublicSiteBehaviour();
    Main.setUpPublicSearchModal();
  }

  static setUpPublicSiteBehaviour() {
    const $openModalButton = document.querySelector(".js-open-modal");
    if ($openModalButton) {
      $openModalButton.addEventListener("click", (e) => {
        e.preventDefault();
        Modal.triggerEvent(
          {
            title: "Sample Title",
            message: "Sample Message",
            modalId: "sample-modal"
          },
          () => {
            // eslint-disable-next-line no-alert
            alert("do something on OK click");
          }
        );
      });
    }
  }

  static setUpPublicSearchModal() {
    const $openModalButton = document.querySelector(".js-open-search-modal");
    if ($openModalButton) {
      $openModalButton.addEventListener("click", (e) => {
        e.preventDefault();
        Modal.triggerEvent({ modalId: "open-search-modal" });
      });
    }
  }
}

export { Main };

window.addEventListener("load", () => {
  // eslint-disable-next-line no-unused-vars
  const main = new Main();
});
